import AppStoreLink from "@/components/shared/AppStoreLink";
import BasicBlock from "@/components/shared/basic-block";
import { IOS_APP } from "@/lib/app-store";
import { useStrings } from "@/lib/i18n/context";

const OfficialAppSection = () => {
  const t = useStrings().officialApp;

  return (
    <BasicBlock wrapperStyle="py-10 md:py-16" contentStyle="justify-center">
      <div className="flex w-full flex-col items-center gap-5 text-center">
        <img
          src={IOS_APP.icon}
          alt=""
          width={72}
          height={72}
          draggable={false}
          className="size-[72px] select-none rounded-[22%] shadow-md"
        />
        <div className="flex flex-col gap-2">
          <h3 className="text-[28px] font-semibold leading-[1.1] text-gray-900 md:text-[36px]">
            {t.heading}
          </h3>
          <p className="max-w-md text-[15px] leading-[1.6] text-[#616885] md:text-base">{t.body}</p>
        </div>
        <AppStoreLink cta="home-app-store" height={48} />
      </div>
    </BasicBlock>
  );
};

export default OfficialAppSection;
